import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import XEUtils from 'xe-utils'
import httpManager from '../../util/common'
import companySearch from '../../home/components/CompanySearch'
import {reportYear} from '../../util/util'
import RevenuePropFilter from '@/common/components/RevenuePropFilter'
import ProductSearch from '@/common/components/ProductSearch'


Vue.use('vxe-table')
let vm = {
  name: 'ProductFilter',
  data: () => {
    return {
      loading: false,
      page: {
        layouts: ['PrevPage', 'Number', 'NextPage'],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        align: 'center',
        perfect: true,
        pagerCount: 3
      },
      // 表格数据
      data: [],
      // 行业选项
      industry_options: [],
      en_industry_options:[
        {
          name:'gics',
          label: 'gics',
          value: '0080008',
          children: []
        },
        {
          name:'citics',
          label: 'citics',
          value: '0089001',
          children: []
        },
        {
          name:'swhy',
          label: 'swhy',
          value: '0080003',
          children: []
        },
        {
          name:'csin',
          label: 'csin',
          value: '0080014',
          children: []
        },
        {
          name:'csrc',
          label: 'csrc',
          value: '0080001',
          children: []
        }
      ],
      zh_industry_options: [
        {
          name:'gics',
          label: 'GICS行业',
          value: '0080008',
          children: []
        },
        {
          name:'citics',
          label: '中信行业',
          value: '0089001',
          children: []
        },
        {
          name:'swhy',
          label: '申万行业',
          value: '0080003',
          children: []
        },
        {
          name:'csin',
          label: '中证行业',
          value: '0080014',
          children: []
        },
        {
          name:'csrc',
          label: '国民经济行业',
          value: '0080001',
          children: []
        }
      ],
      industry: null,
      standard_product_options:  [],
      // 年份
      fil_year_options: [],
      revenue_proportion_options: [],
      // 产品
      product: null,
      // 标准化产品
      standard_product: null,
      // 上市公司
      short_name: null,
      // 年份
      end_date: null,
      // 营收占比
      product_label_revper_pre: null,
      product_label_revper_back: null,
      // 行业标签
      industry_option: null,
      follow_entity_supplier: false,
      // 排序
      order_col: null,
      asc_order: null,
      isGreen: false,
      product_label: null
    }
  },
  methods: {
    openDataExport() {
      let s = "产业链"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv'],
        modes: ['current']
      })
    },
    getYear(n) {
      const arr = []
      const date = new Date()
      const curDate = date.getFullYear()
      for (let i = 0; i < n; i++) {
        arr.push({ label:`${curDate - i}`, value: curDate - i})
      }
      this.fil_year_options = arr
    },
    changeMin(value) {
      this.product_label_revper_pre = value
    },
    changeMax(value) {
      this.product_label_revper_back = value
    },
    clearData() {
      this.$refs.revenuePropRef.clear()
      this.industry_option = null
      this.short_name = null
      this.end_date = null
      this.industry = null
      this.order_col = null
      this.asc_order = null
      this.product = null
      this.standard_product = null
      this.$refs.xTable_data.clearSort()
      this.$refs.companySearch.clear()
      this.$nextTick(() => {
        this.product_label_revper_pre = null
        this.product_label_revper_back = null
      })
    },
    searchData() {
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getProductChainFilterData()
    },
    gicsFilter(inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    // 排序按钮事件
    sortChangeEvent({ column, property, order }){
      this.order_col = property
      this.asc_order= order
      if (!this.asc_order) {
        this.order_col = null
      }
      this.page.currentPage = 1
      this.page.pageSize = 10
      this.getProductChainFilterData()
    },
    // 页面变化
    pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getProductChainFilterData()
    },
    //时间戳转换成标准时间
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear();
      return Y;
    },
    washTree(tree) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children) {
          this.washTree(tree[i].children)
        }
        if (tree[i].label === '' && tree[i].value === '') {
          tree.splice(i, 1)
        }
      }
    },
    getStatisticsData () {
      let self = this
      let lang = this.$i18n.locale
      let arr = []
      for (let i = 0; i < self.zh_industry_options.length; i++) {
        let Promise = reportYear.gics_industry(`${self.zh_industry_options[i].name}_industry_tree_` + lang, self.zh_industry_options[i].name).then(result => {
          self.zh_industry_options[i].children = result
          self.en_industry_options[i].children = JSON.parse(sessionStorage.getItem(`${self.zh_industry_options[i].name}_industry_tree_en`))
          self.zh_industry_options[i].children = JSON.parse(sessionStorage.getItem(`${self.zh_industry_options[i].name}_industry_tree_zh`))
        })
        arr.push(Promise)
      }
      let promise2 = httpManager('standard_category_list').then((res) => {
        this.standard_product_options = res.data.data
      })
      arr.push(promise2)
      return arr 
    },
    // 获取表格数据
    getProductChainFilterData() {
      this.loading=true
      let params = new Map()
      params.set("pagenum", this.page.currentPage)
      params.set("pagesize", this.page.pageSize)
      if (this.product) {
        params.set("product", this.product)
      }
      if (this.standard_product && this.standard_product.length !== 0) {
        const standard_product = this.standard_product[this.standard_product.length - 1]
        params.set("standard_product_l"+ this.standard_product.length, standard_product )
      }
      if (this.short_name) {
        params.set("oaid", this.short_name)
      }
      if (this.end_date) {
        params.set("year", this.end_date)
      }
      if(this.industry_option){
        if(this.short_name && this.industry_option[1]) {
          this.$message.warning(this.$t('tips.product_filter_entity_industry_tip'));
          return this.loading=false
        }
        if (this.industry_option[1]) {
          const industry_type = this.industry_option[0]
          const industry_code = this.industry_option[this.industry_option.length - 1]
          params.set("industry_type", industry_type)
          params.set("industry_code", industry_code)
        }
      }
      if (this.product_label_revper_pre || this.product_label_revper_back) {
        params.set('percent_min', this.product_label_revper_pre ? this.product_label_revper_pre : 0)
        params.set('percent_max', this.product_label_revper_back ? this.product_label_revper_back : 100)
      }
      if(this.order_col){
        params.set('order_col', this.order_col)
      }
      if(this.asc_order){
        params.set('asc_order', this.asc_order === 'asc' ? true : false)
      }
      httpManager("industry_chain_product_filter",params,null,null,null)
      .then(response=>{
        this.data=response.data.data
        let page = response.data.page
        this.page.total = page.total
        this.loading=false
      })
      .catch((error)=>{
        this.loading = false
        console.log(error);
      })
    } 
  },
  computed: {
    tableColumn() {
      return [
        {title: 'i18n.common.ticker', field: 'ticker', className: 'click-cell-style'},
        {title: 'i18n.user_center.entity_name', field: 'full_name', type:"html", className: "click-cell-style",
          formatter: ({row}) => {
            return '<a target="_blank" href="/entity/'+row.full_name+'/revenue/breakdown">'+row.full_name+'</a>'
          }},
        {title: 'i18n.supplychain.fil_year', field: 'start_date', sortable: true, formatter: ({cellValue}) => { return cellValue ? this.timestampToTime(cellValue) + '年': ''}},
        {title: 'i18n.supplychain.product', field: 'product_name' },
        {title: 'i18n.supplychain.standard_product', field: 'standardized_product_name'},
        {title: 'i18n.supplychain.concept_label', field: 'product_label'},
        {title: 'i18n.supplychain.revenue', field: 'product_revenue_avemethod', sortable: true, formatter: ({cellValue}) => { return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue)/10000, {digits: 2})}` : ''}},
        {title: 'i18n.supplychain.revenue_proportion%', field: 'product_revenue_percentage_avemethod', sortable: true,  formatter: ({cellValue}) => { return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''}}
      ]
    },
    lang() {
      return this.$i18n.locale
    }
  },
  created() {
    // 获取最近12年的年份
    this.getYear(12)
    // 获取行业分类信息和标签
    Promise.all(this.getStatisticsData()).then((res) => {
      this.washTree(this.en_industry_options)
      this.washTree(this.zh_industry_options)
      this.industry_options = this.zh_industry_options
    })
    this.getProductChainFilterData()
  },
  watch: {
    lang(val) {
      if (val === 'zh') {
        this.industry_options = this.zh_industry_options
      } else {
        this.industry_options = this.en_industry_options
      }
    }
  },
  components: { RevenuePropFilter }
}

export default vm


// WEBPACK FOOTER //
// ./src/supplychain/js/product_filter.js